// Componente per sistema ExeDialog DDT2026 - Step rag_soc_conducente
// Autocomplete che chiama verificaDdt ad ogni carattere digitato
import React, { useState, useRef, useEffect } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ValoriVerificati } from './ValoriVerificati';

export function RagSocConducente(props) {
    const { currURLSearchParams, onFinish, verificaData, verificaDdt, buildInputFromSearchParams } = props;
    const inputRef = useRef();
    
    const [state, setState] = useState({
        rag_soc_conducente: currURLSearchParams.get('rag_soc_conducente') || ''
    });
    const [suggestions, setSuggestions] = useState([]);
    const [searching, setSearching] = useState(false);

    // righe_suggerimento dalla risposta iniziale
    const suggerimenti = verificaData?.righe_suggerimento || [];

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.rag_soc_conducente) {
            onFinish({ rag_soc_conducente: state.rag_soc_conducente });
        }
    };

    // Seleziona riga dalla tabella suggerimenti (campo singolo: avanza automaticamente)
    const handleRowSelect = (e) => {
        const row = e.data;
        onFinish({ rag_soc_conducente: row.rag_soc_conducente });
    };

    // Chiama verificaDdt ad ogni carattere digitato
    const searchOptions = async (event) => {
        const query = event.query;
        if (!query || query.length < 1) {
            setSuggestions([]);
            return;
        }

        setSearching(true);
        try {
            const currentInput = buildInputFromSearchParams(currURLSearchParams);
            const input = {
                ...currentInput,
                rag_soc_conducente: query
            };
            
            const result = await verificaDdt(input);
            // Se il campo è stato verificato (campo_da_verificare è passato al successivo),
            // mostra il valore verificato come unica opzione confermabile
            if (result?.campo_da_verificare !== 'rag_soc_conducente') {
                const v = result?.valori_verificati;
                setSuggestions(v?.rag_soc_conducente ? [{ rag_soc_conducente: v.rag_soc_conducente, conducente: v.conducente }] : []);
            } else {
                setSuggestions(result?.opzioni_selezione || []);
            }
        } catch (err) {
            console.error('Errore ricerca:', err);
            setSuggestions([]);
        } finally {
            setSearching(false);
        }
    };

    const itemTemplate = (item) => (
        <span>{item.rag_soc_conducente} <span style={{fontSize: 'x-small', color: '#666'}}>({item.conducente})</span></span>
    );

    return (
        <div className="card-body">
            <h5 className="card-title">Conducente</h5>
            <p className="text-muted">Digita per cercare il conducente o seleziona dalla tabella.</p>
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="rag_soc_conducente" className="form-label">Ragione Sociale Conducente</label>
                    <AutoComplete 
                        ref={inputRef}
                        id="rag_soc_conducente"
                        value={state.rag_soc_conducente}
                        suggestions={suggestions}
                        completeMethod={searchOptions}
                        field="rag_soc_conducente"
                        onChange={(e) => {
                            const value = typeof e.value === 'object' ? e.value.rag_soc_conducente : e.value;
                            setState({ rag_soc_conducente: value });
                        }}
                        onSelect={(e) => onFinish({ rag_soc_conducente: e.value.rag_soc_conducente })}
                        itemTemplate={itemTemplate}
                        className="w-100"
                        inputClassName="w-100"
                        minLength={1}
                        delay={300}
                    />
                    {searching && <small className="text-muted">Ricerca in corso...</small>}
                </div>

                {suggerimenti.length > 0 && (
                    <div className="mb-3">
                        <label className="form-label">Conducenti suggeriti</label>
                        <DataTable 
                            value={suggerimenti} 
                            selectionMode="single" 
                            onRowSelect={handleRowSelect}
                            size="small"
                            scrollable
                            scrollHeight="400px"
                        >
                            <Column field="rag_soc_conducente" header="Ragione Sociale" />
                            <Column field="conducente" header="Codice" />
                        </DataTable>
                    </div>
                )}

                <button className="btn btn-primary" disabled={!state.rag_soc_conducente}>
                    Prosegui
                </button>
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

RagSocConducente.displayName = 'rag_soc_conducente';
